<template>
  <div ref="el">
    <slot />
  </div>
</template>

<script lang="ts" setup generic="T extends { id: string | number }">
import { useSortable } from '@vueuse/integrations/useSortable'
import { computed, ref, watch } from 'vue'
import type { SortEvent } from './types'

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    list: T[]
    draggableSelector?: string
  }>(),
  { disabled: false, draggableSelector: undefined },
)

const emit = defineEmits<{ (e: 'sort', evt: SortEvent): void }>()

const el = ref<HTMLElement>()

const { option } = useSortable(
  el,
  computed(() => props.list),
  {
    animation: 200,
    ghostClass: 'sortable-ghost-item',
    handle: props.draggableSelector,
    disabled: props.disabled,
    onSort(e) {
      emit('sort', {
        item: e.item,
        newDraggableIndex: e.newDraggableIndex,
        newIndex: e.newIndex,
        oldDraggableIndex: e.oldDraggableIndex,
        oldIndex: e.oldIndex,
      })
    },
  },
)

watch(
  () => props.disabled,
  () => option('disabled', props.disabled),
)

watch(
  () => props.draggableSelector,
  () => option('handle', props.draggableSelector),
)
</script>

<style lang="scss" scoped>
// eslint-disable-next-line vue-scoped-css/no-unused-selector
.sortable-ghost-item {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    border-top: 2px solid var(--color-border-focused);
  }
}
</style>
